// extracted by mini-css-extract-plugin
module.exports = {"form":"EAFRegisterRecord_form__1Ia-p","content":"EAFRegisterRecord_content__SwsCU","contentMain":"EAFRegisterRecord_contentMain__2SwZ9","select":"EAFRegisterRecord_select__28AQq"};